<i [class]="iconClass" [style.color]="iconColor"></i>
